import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { PlannerChecklistHeading } from "./PlannerChecklistHeading";
import { CategoryTabs } from "../CategoryTabs";
import { usePlanner } from "../../../TripPlanner";
import { PlannerTree } from "../../../TripPlanner";
import { useTripPlanerContext } from "../TripPlannerContext";
import { PlannerResourceType } from "@parkschannel/contracts";
import { FormUI } from "@parkschannel/ui";
export const PlannerChecklist = (param)=>{
    let { children  } = param;
    const { planner  } = useTripPlanerContext();
    const { usePlannerQuery  } = usePlanner();
    const { data  } = usePlannerQuery([
        ...planner.filters[PlannerResourceType.ACTIVITY],
        ...planner.filters[PlannerResourceType.PLACE]
    ]);
    return /*#__PURE__*/ _jsx("section", {
        className: "bg-white py-6 px-4 rounded-2xl md:px-6 ",
        children: /*#__PURE__*/ _jsxs(FormUI.Step, {
            className: "w-full",
            stepClassName: "!items-start",
            step: 3,
            status: "active",
            title: ()=>/*#__PURE__*/ _jsx(PlannerChecklistHeading, {}),
            children: [
                /*#__PURE__*/ _jsx(CategoryTabs, {
                    data: data ? PlannerTree.fromPlannerResourceDto(data) : undefined
                }),
                children
            ]
        })
    });
};
